module.exports = __webpack_public_path__ + "img/user-avatar.0ef6529e.png";